import { matchPath } from 'react-router';

import { PageTags, Params } from './types';

class ProjectPageTags extends PageTags {
  static get({ pathname, exact }: Params) {
    let currentPage = '';
    // eslint-disable-next-line no-restricted-syntax
    for (const [path] of Object.entries(this.container)) {
      const currentRoutePath = matchPath(pathname, { path, exact });
      if (currentRoutePath) {
        currentPage = path;
        break;
      }
    }

    if (this.container[currentPage]) {
      return this.container[currentPage];
    }
    return undefined;
  }

  static get container(): {[key: string]: string[]} {
    return {
      '/dashboard/projects': this.projects,
      '/dashboard/projects/:id/overview': this.overview,
      '/dashboard/projects/:id/media': this.media,
      '/dashboard/projects/:id/scripts': this.scripts,
      '/dashboard/projects/:id/scripts/studio': this.studio,
      '/dashboard/projects/:id/activity': this.activity,
    };
  }

  static get projects() {
    return [
      'tag:project',
      'tag:list',
    ];
  }

  static get overview() {
    return [
      'tag:project',
      'tag:overview',
      'tag:studio',
      'tag:detail',
    ];
  }

  static get scripts() {
    return [
      'tag:project',
      'tag:script',
      'tag:studio',
    ];
  }

  static get media() {
    return [
      'tag:media',
      'tag:preview',
      'tag:upload',
      'tag:download',
      'tag:export',
    ];
  }

  static get activity() {
    return [
      'tag:activity',
      'tag:status',
    ];
  }

  static get studio() {
    return [
      'tag:studio',
      'tag:camera',
    ];
  }
}


export default ProjectPageTags;
